/**
* 左边菜单
*/ 
<template>
  <el-menu
    default-active="1"
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    active-text-color="#02A7F0"
  >
    <el-menu-item
      class="side-menu-item"
      active-text-color="#0094FF"
      v-for="chmenu in allmenu"
      :index="'/' + chmenu.url"
      :key="chmenu.menuid"
    >
      <span class="iconfont" :class="chmenu.icon"></span>
      <span style="margin:0px 0px 0px 5px">{{ chmenu.menuname }}</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
import { menu } from "../api/userMG";
import "../assets/icon/ali icon/iconfont.css";
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "iconfont icon-shouye",
          menuname: "Home",
          hasThird: "N",
          url: "map/map",
        },
        {
          menuid: 2,
          icon: "iconfont icon-dikuai",
          menuname: "Farmland",
          hasThird: "N",
          url: "fieldManage",
        },
        {
          menuid: 3,
          icon: "iconfont icon-tongzhi",
          menuname: "Message",
          hasThird: "N",
          url: "message",
        },
      ],
      msg: "success",
    };
    this.allmenu = res.data;

    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu {
  border: none;
}

.el-submenu__icon-arrow {
  visibility: hidden;
}
.side-menu-item {
  /* color: white; */
  /* background-color: #0094ff; */
  padding: 10px 0px 10px 0px;
  height: 80px;
  font-size: 16px;
  border-bottom: solid rgba(80, 80, 80, 0.2) thin;;
}

</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue